import { TablePage } from "@outpave/ds";
import CustomFieldSettingsDrawer from "components/admin/settings/CustomFields/CustomFieldSettingsDrawer";
import CustomFieldSettingsTable from "components/admin/settings/CustomFields/CustomFieldSettingsTable";
import CustomFieldStatus from "enums/CustomFieldStatus";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

export type CustomFieldFilterProps = {
  status: CustomFieldStatus;
};

const sections = [
  {
    id: "active",
    label: "Active",
    status: CustomFieldStatus.ACTIVE,
  },
  {
    id: "readOnly",
    label: "Read Only",
    status: CustomFieldStatus.READONLY,
  },
  {
    id: "disabled",
    label: "Disabled",
    status: CustomFieldStatus.DISABLED,
  },
];

const CustomFields: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(t("Custom Fields"));

  const [activeTab, setActiveTab] = React.useState(0);
  const [openCustomFienldsDrawer, setOpenCustomFieldSettingsDrawer] =
    useState<boolean>(false);
  const [selectedFieldId, setSelectedFieldId] = useState<string>("");
  const [refreshCustomFieldSettings, setRefreshCustomFieldSettings] =
    useState<number>(0);

  const [filterCriteria, setFilterCriteria] = useState<CustomFieldFilterProps>({
    status: CustomFieldStatus.ACTIVE,
  });

  useEffect(() => {
    setFilterCriteria({
      status: sections[activeTab].status,
    });
  }, [activeTab]);

  const handleOpenDrawer = (fieldId?: string) => {
    setSelectedFieldId(fieldId || "");
    setOpenCustomFieldSettingsDrawer(true);
  };

  const handleCloseDrawer = (refresh?: boolean) => {
    if (refresh) {
      setRefreshCustomFieldSettings((prev) => prev + 1);
    }
    setOpenCustomFieldSettingsDrawer(false);
    setSelectedFieldId("");
  };

  return (
    <>
      <TablePage
        title={t("Custom Fields")}
        breadcrumbs={breadcrumbs}
        primaryAction={
          <Button onClick={() => handleOpenDrawer()}>
            {t("Create Field")}
          </Button>
        }
        tabs={{
          items: sections.map((tab, index) => ({
            id: String(index),
            label: t(tab.label),
          })),
          activeId: String(activeTab),
          onChange: (id) => setActiveTab(Number(id)),
        }}
      >
        <CustomFieldSettingsTable
          filterCriteria={filterCriteria}
          handleOpenDrawer={handleOpenDrawer}
          refreshCustomFieldSettings={refreshCustomFieldSettings}
        />

        <CustomFieldSettingsDrawer
          open={openCustomFienldsDrawer}
          handleCloseDrawer={handleCloseDrawer}
          selectedFieldId={selectedFieldId}
        />
      </TablePage>
    </>
  );
};

export default CustomFields;
